const images = require.context("../images", true)
const audios = require.context("../audios", true)

const content = {
	images: [
		{
			src: images("./25to33/page06_bg.png"),
			imgdiv: "imageCover bg-blue-sky",
		},
		{
			src: images("./25to33/img01.svg"),
			imgdiv: "imageCover endc-1",
		},
		{
			src: images("./1to5/bush01.png"),
			imgdiv: "imageCover bush-left ble-a1",
		},
		{
			src: images("./1to5/bush02.png"),
			imgdiv: "imageCover bush-right bre-a1",
		},
	],
	texts: [
		{
			textDivClass: "story-text text-center bg-success h-auto position-bottom-intact textContentDiv w-75  ",
			textIndivData: [
				{
					textData: "पानीहाँसहरू आफ्‍नो साथीलाई बचाउन सकेकामा खूब खुसी भए।",
					textClass: "fz-5 m-0",
					timestamps: [
						{ start: 0 },
						{ start: 1 },
						{ start: 1.5 },
						{ start: 2.1 },
						{ start: 2.6 },
						{ start: 3.55 },
						{ start: 3.9 },
						{ start: 4.4 },
						{ start: 5 },
					],
				},
			],
		},
	],
	sounds: [
		{
			url: audios("./p5_s6.ogg"),
			delay: 250,
		},
	],
}

export default content
